import React from "react";
import { ICON } from "../../assets";
import UiIcon from "../ui/UiIcon";
import "./loyalty.css";
import UiStarBadge from "../ui/UiStarBadge";
import { useAuth } from "../Auth/useAuth";

function Loyalty({ closeLoyalty, rewardRating }) {
  const [auth] = useAuth();
  const userLoyaltyReward = auth?.user?.data.loyalty_reward;
  const lang = "fr";

  function renderLoyaltyDialogItem() {
    const renderUiStarBadgeWithSeperator = (item, index) => {
      const isFirstItem = index === 0;
      const isLastItem = index === rewardRating.length - 1;
      return (
        <React.Fragment>
          <div className="loyalty-dialog__item-header">
            <div
              className={
                isFirstItem
                  ? "loyalty-dialog__separator--white"
                  : "loyalty-dialog__separator"
              }
            ></div>
            <div className="loyalty-dialog__badge">
              <UiStarBadge content={item.rating} />
            </div>
            <div
              className={
                isLastItem
                  ? "loyalty-dialog__separator--white"
                  : "loyalty-dialog__separator"
              }
            ></div>
          </div>
        </React.Fragment>
      );
    };

    return rewardRating.map((item, index) => (
      <React.Fragment key={index}>
        <div className="loyalty-dialog__item">
          {renderUiStarBadgeWithSeperator(item, index)}
          <div className="loyalty-dialog__item--info">
            <span className="loyalty-dialog__amount">
              {item.amount?.toLocaleString(lang)} €
            </span>
            <span className="loyalty-dialog__text">{item.text}</span>
            <p className="loyalty-dialog__desc">{item.description}</p>
          </div>
        </div>
      </React.Fragment>
    ));
  }
  const currentYear = new Date().getFullYear().toLocaleString().split(0, 2)[1];

  return (
    <React.Fragment>
      <div className="loyalty-dialog">
        <UiIcon
          className="loyalty-dialog__close-icon"
          icon={ICON.closeCrossIcon}
          onClick={() => closeLoyalty(false)}
          size="md"
        />
        {userLoyaltyReward ? (
          <div>
            <div className="loyalty-dialog__header">
              <span className="loyalty-dialog__title">
                Le programme de fidélité Blancrème
              </span>
              <span className="loyalty-dialog__date">
                valable du 01/01/{currentYear} au 31/12/{currentYear}
              </span>
            </div>
            <div className="loyalty-dialog__list">
              {renderLoyaltyDialogItem()}
            </div>
          </div>
        ) : (
          <p className="loyalty-error">
            Nous ne sommes actuellement pas en mesure de récupérer vos données
            de fidélité. Veuillez contacter notre service client pour obtenir de
            l'aide.
          </p>
        )}
      </div>
    </React.Fragment>
  );
}

export default Loyalty;
